module.exports = __webpack_public_path__ + "img/icon_twitter.0ccf81da.svg";